import { useEffect } from 'react'
import { createTheme, ThemeProvider } from '@mui/material'
import Nav from "./components/Nav"
import { Route, Routes } from 'react-router-dom'

import { Toolbar } from '@mui/material'

import store from './store'
import { CLEAR_ERRORS } from './constants/globalConstants'
import { useLocation } from 'react-router-dom'

import Login from './screens/users/Login'
import Profile from './screens/users/profile/Profile'
import NotFound from './screens/NotFound'
import ForgotPassword from './screens/users/ForgotPassword'
import ResetPassword from './screens/users/ResetPassword'
import Settings from './screens/users/profile/Settings'
import NewSong from './screens/songs/NewSong'
import Home from './screens/Home'
import EditSong from './screens/songs/EditSong'
import AddPlaylist from './screens/playlists/AddPlaylist'
import Playlists from './screens/users/profile/Playlists'
import AddSongToPlaylist from './screens/playlists/AddSongToPlaylist'
import EditPlaylist from './screens/playlists/EditPlaylist'

const theme = createTheme({
  typography: {
    allVariants: {
      color: "rgba(0, 0, 0, 0.8)"
    }
  },
  palette: {
    primary: {
      main: '#1366f2'
    },
    background: {
      default: '#fbfbfb',
    },
    secondary: {
      main: '#df113f'
    }
  },
  shadows: {
    "0": "none",
    "1": "rgba(149, 157, 165, 0.2) 0px 2px 2px",
    "2": "rgba(0, 0, 0, 0.1) 0px 4px 12px",
    "3": "rgba(149, 157, 165, 0.2) 0px 8px 24px",
  },
})

function App() {
  const location = useLocation()

  useEffect(() => {
    store.dispatch({ type: CLEAR_ERRORS })

    if (window.location.protocol === 'http:') {
      window.location.href = 'https://eclesiasongs.com'
    }
  }, [])

  useEffect(() => {
    store.dispatch({ type: CLEAR_ERRORS })
  }, [location])

  return (
    <ThemeProvider theme={theme}>
      <Nav />
      <Toolbar />
      <Routes>
        <Route exact path='/' element={<Home />} />

        <Route exact path='/add-playlist' element={<AddPlaylist />} />
        <Route exact path='/playlists/:playlistId' element={<Home />} />
        <Route exact path='/edit/playlists/:id' element={<EditPlaylist />} />
        <Route exact path='/playlists/:playlistId/:songId' element={<Home />} />
        <Route exact path='/playlist/add/:id' element={<AddSongToPlaylist />} />

        <Route exact path='/song/:id' element={<Home />} />
        <Route exact path='/edit/song/:id' element={<EditSong />} />
        <Route exact path='/add-song' element={<NewSong />} />

        <Route exact path='/login' element={<Login />} />
        <Route exact path='/profile' element={<Profile />} />
        <Route exact path='/profile/playlists' element={<Playlists />} />
        <Route exact path='/profile/settings' element={<Settings />} />
        <Route exact path='/forgot-password' element={<ForgotPassword />} />
        <Route exact path='/reset-password/:token' element={<ResetPassword />} />

        <Route path='*' element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  )
}

export default App
